import type { Ref } from 'vue'

const useScrollTo = (
  ref: Ref<HTMLElement>,
  targetClass: `.${string}`,
  behavior?: ScrollBehavior
) => {
  const scrollToSelected = () => {
    if (!ref.value) return
    const container = ref.value
    const elementToScrollTo = container.querySelector(targetClass) as HTMLElement
    const containerPaddingOffset = parseInt(getComputedStyle(ref.value).paddingTop)
    if (elementToScrollTo) {
      const scrollContainerBy = elementToScrollTo.offsetTop - containerPaddingOffset
      container.scrollTo({ top: scrollContainerBy, behavior: behavior ?? 'smooth' })
    }
  }

  return { scrollToSelected }
}

export default useScrollTo
